import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-folder-module',
  templateUrl: './main-folder.component.html',
  styleUrls: ['./main-folder.component.css']
})
export class MainFolderModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
